import type { OutputStep, OutputStepKind } from "./events";

const KIND: Record<
  OutputStepKind,
  { type: string; running: string; done: string }
> = {
  course: { type: "Course", running: "Drafting", done: "Draft ready" },
  module: { type: "Module", running: "Drafting", done: "Draft ready" },
  checklist: { type: "Checklist", running: "Drafting", done: "Draft ready" },
  checkin: { type: "Check-in", running: "Drafting", done: "Draft ready" },
  document: { type: "Document", running: "Drafting", done: "Draft ready" },
  upload: { type: "File", running: "Uploading", done: "Uploaded" },
  change: { type: "Change", running: "Applying", done: "Applied" },
};

/**
 * What the agent is making, as one quiet line under its status row:
 * "Module · BOH: Meet Our Restaurants · Draft ready". It goes with the row
 * once the result (the reply) is on screen; there is no card in the chat.
 */
export const outputStatusLine = (step: OutputStep): string => {
  const kind = KIND[step.kind];
  const head = step.title ? `${kind.type} · ${step.title}` : kind.type;
  switch (step.status) {
    case "RUNNING":
      return `${head} · ${kind.running}…`;
    case "STOPPED":
      return `${head} · Stopped`;
    case "FAILED":
      return `${head} · ${step.errorSummary || "Couldn't finish"}`;
    default:
      return `${head} · ${kind.done}`;
  }
};
